var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"third-party"},[_c('router-view',{staticStyle:{"background-color":"white","min-height":"100vh"},style:({padding: (_vm.dlgFullScreen == '1' ? '0px' : '20px')})})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }